import React from 'react';
import PropTypes from 'prop-types';

const Thick = ({ color = '#838B93' }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <polygon
                id="thick-path-1"
                points="0.911510838 4.98970276 0.0515582836 5.70209528 3.32770568 9.75632768 9.9493872 1.77483656 9.09860401 1.05124546 3.33896099 7.99367232"
            />
        </defs>
        <g
            id="Svg-Icons/10px-(All-icons)/thick"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#thick-path-1" />
            </mask>
            <use id="Mask" fill={color} xlinkHref="#thick-path-1" />
        </g>
    </svg>
);

Thick.propTypes = {
    color: PropTypes.string,
};

export default Thick;
